import { FormHelperText, FormLabel, Grid, InputLabel, Typography } from '@material-ui/core';
import './loanStyle.scss';

import { Alert } from '@material-ui/lab';
import { SignPad } from '../../../Core/SignaturePad/SignPad';
import { CustomeSignPad } from '../../../Core/SignaturePad';
import { useContext } from 'react';
import { LoanVehicleContext } from './loanVehicle-provider';
import ImageUploadModal from './ImageUpload/ImageUploadModal';
import BackupIcon from '@material-ui/icons/Backup';
import { DateTimePicker } from '../../../Core/FormInput';
import formatters from '../../../Core/Grid/inputFormatter';

export function HandoverOUtSignature() {
    const { fieldChange, clearSig, state, handleOutImageUpload, handleOutRemoveImage, loanVehicleOutImages, errors, bookingDetails, handleBookingDetails } =
        useContext(LoanVehicleContext);
    return (
        <Grid container spacing={1} className="mainSection">
            <Grid item xs={12}>
                <div color="secondary" className="Loan_Veh_heading" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Vehicle Handover - OUT</span>
                    <ImageUploadModal
                        title="Vehicle Handover - OUT"
                        handleImageUpload={handleOutImageUpload}
                        handleRemoveImage={handleOutRemoveImage}
                        images={loanVehicleOutImages}
                        disabled={state.isVehicleReceived}
                    />
                </div>
            </Grid>
            <Grid item xs={12}>
                <Alert severity="info" icon={false}>
                    Please upload images of any external vehicle damage before the vehicle leaves the premises.
                </Alert>
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                    Date Out
                </InputLabel>
                <DateTimePicker
                    name="dateOut"
                    value={bookingDetails.dateOut}
                    onChange={handleBookingDetails}
                    required
                    disabled={state.isVehicleReceived || state.isReadonly}
                />
                {errors.dateOut && <FormHelperText error>{errors.dateOut}</FormHelperText>}
            </Grid>

            <Grid item xs={12}>
                {state.handoverCustomerSignatureOut ? (
                    <>
                        <FormLabel component="legend" required error>
                            Signature
                        </FormLabel>{' '}
                        &nbsp;&nbsp; (
                        <small>
                            {state.customerSignatureOutSignUser ? state.customerSignatureOutSignUser : ''} -
                            {state.customerSignatureOutSignDate ? formatters.DateTimeFormatter(state.customerSignatureOutSignDate) : ''}
                        </small>
                        )
                        <br />
                        <div style={{ width: '100%', height: '177px', border: '1px solid #f5f5f5' }}>
                            <img src={state.handoverCustomerSignatureOut} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        </div>
                    </>
                ) : (
                    <CustomeSignPad
                        content="Signature"
                        onChange={fieldChange}
                        clearSig={clearSig}
                        sign={state.handoverCustomerSignatureOut}
                        name="handoverCustomerSignatureOut"
                        isRequired
                        disabled={state.isVehicleReceived}
                    />
                )}
                {errors.handoverStaffSignatureOut && <FormHelperText error>{errors.handoverStaffSignatureOut}</FormHelperText>}
            </Grid>

            {/* <Grid item xs={12}>
                {state.handoverStaffSignatureOut ? (
                    <>
                        <FormLabel component="legend" required error>
                            Staff signature
                        </FormLabel>
                        <br />
                        <div style={{ width: '100%', height: '177px', border: '1px solid #f5f5f5' }}>
                            <img src={state.handoverStaffSignatureOut} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        </div>
                    </>
                ) : (
                    <CustomeSignPad
                        content="Staff Signature"
                        onChange={fieldChange}
                        clearSig={clearSig}
                        sign={state.handoverStaffSignatureOut}
                        name="handoverStaffSignatureOut"
                        isRequired
                        disabled={state.isVehicleReceived}
                    />
                )}
                {errors.handoverStaffSignatureOut && <FormHelperText error>{errors.handoverStaffSignatureOut}</FormHelperText>}
            </Grid> */}
        </Grid>
    );
}
export function HandoverReturnSignature() {
    const { fieldChange, clearSig, state, handleInImageUpload, handleInRemoveImage, loanVehicleInImages, errors, bookingDetails, handleBookingDetails } =
        useContext(LoanVehicleContext);
    return (
        <Grid container spacing={1} className="mainSection">
            <Grid item xs={12}>
                <div color="secondary" className="Loan_Veh_heading" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Vehicle Handover - RETURN</span>
                    <ImageUploadModal
                        title="Vehicle Handover - RETURN"
                        handleImageUpload={handleInImageUpload}
                        handleRemoveImage={handleInRemoveImage}
                        images={loanVehicleInImages}
                        disabled={state.isVehicleReceived}
                    />
                </div>
            </Grid>
            <Grid item xs={12}>
                <Alert severity="info" icon={false} style={{ fontSize: '13px' }}>
                    Please upload images of any external vehicle damage before the vehicle leaves the premises.
                </Alert>
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                    Date In
                </InputLabel>
                <DateTimePicker
                    name="dateIn"
                    value={bookingDetails.dateIn}
                    onChange={handleBookingDetails}
                    minDate={bookingDetails.dateOut}
                    disabled={state.isVehicleReceived}
                    inputProps={{
                        min: bookingDetails.dateOut
                    }}
                />
                {errors.dateIn && <FormHelperText error>{errors.dateIn}</FormHelperText>}
            </Grid>

            <Grid item xs={12}>
                {state.handoverCustomerSignatureIn ? (
                    <>
                        <InputLabel shrink component="legend" required error>
                            Signature
                        </InputLabel>{' '}
                        &nbsp;&nbsp; (
                        <small>
                            {state.customerReturnSignatureSignUser ? state.customerReturnSignatureSignUser : ''} -
                            {state.customerReturnSignatureSignDate ? formatters.DateTimeFormatter(state.customerReturnSignatureSignDate) : ''}
                        </small>
                        )
                        <br />
                        <div style={{ width: '100%', height: '177px', border: '1px solid #f5f5f5' }}>
                            <img src={state.handoverCustomerSignatureIn} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        </div>
                    </>
                ) : (
                    <CustomeSignPad
                        content="Signature"
                        onChange={fieldChange}
                        clearSig={clearSig}
                        sign={state.handoverCustomerSignatureIn}
                        name="handoverCustomerSignatureIn"
                        isRequired
                        disabled={state.isVehicleReceived}
                    />
                )}
                {errors.handoverCustomerSignatureIn && <FormHelperText error>{errors.handoverCustomerSignatureIn}</FormHelperText>}
            </Grid>
            {/* <Grid item xs={12}>
                {state.handoverStaffSignatureIn ? (
                    <>
                        <FormLabel component="legend" required error>
                            Staff signature
                        </FormLabel>
                        <br />
                        <div style={{ width: '100%', height: '177px', border: '1px solid #f5f5f5' }}>
                            <img src={state.handoverStaffSignatureIn} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        </div>
                    </>
                ) : (
                    <CustomeSignPad
                        content="Staff Signature"
                        onChange={fieldChange}
                        clearSig={clearSig}
                        sign={state.handoverStaffSignatureIn}
                        name="handoverStaffSignatureIn"
                        isRequired
                        disabled={state.isVehicleReceived}
                    />
                )}
                {errors.handoverStaffSignatureIn && <FormHelperText error>{errors.handoverStaffSignatureIn}</FormHelperText>}
            </Grid> */}
        </Grid>
    );
}
